export default function SHorizontalSpacing({ size = 20, color="currentColor", className = "", ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="8 10 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M21.2015 26.4121L19.2015 26.4121L19.2015 10.4121L21.2015 10.4121L21.2015 26.4121ZM18.2015 26.4121L16.2015 26.4121L16.2015 10.4121L18.2015 10.4121L18.2015 26.4121ZM29.2015 19.4121L26.0015 19.4121L27.6015 21.0121L26.2015 22.4121L22.2015 18.4121L26.2015 14.4121L27.6015 15.8121L26.0515 17.4121L29.2015 17.4121L29.2015 19.4121ZM15.2015 18.4121L11.2015 22.4121L9.80154 21.0121L11.4015 19.4121L8.20154 19.4121L8.20154 17.4121L11.4015 17.4121L9.80154 15.8121L11.2015 14.4121L15.2015 18.4121Z"
            fill={color}/>
    </svg>
  )
}